import { render, staticRenderFns } from "./DocumentosS1.vue?vue&type=template&id=26363a10&"
import script from "./DocumentosS1.vue?vue&type=script&lang=js&"
export * from "./DocumentosS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports